import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-photo-view/dist/react-photo-view.css';
import { Provider } from 'react-redux';
import 'react-tagsinput/react-tagsinput.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Redux
// https://github.com/rt2zz/redux-persist
import { PersistGate } from 'redux-persist/integration/react';
// Axios
import axios from 'axios';
// Bootstrap Bundle JS
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Chart, registerables } from 'chart.js';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 **/
import './_metronic/assets/sass/style.scss';
import './assets/sass/_modals.scss';
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n';
// Apps
import { App } from './app/App';
import store, { persistor } from './services/redux/app/store';
import * as _redux from './setup';

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

// /* const mock = */ _redux.mockAxios(axios)
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store);

Chart.register(...registerables);

// iOS'ta input zoom'unu engellemek ve blur'da viewport'u sıfırlamak için
if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
  // Input blur olduğunda viewport'u sıfırla
  document.addEventListener(
    'blur',
    (e) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') {
        // Küçük bir gecikme ile scroll pozisyonunu düzelt
        setTimeout(() => {
          window.scrollTo({ top: window.scrollY, behavior: 'auto' });
        }, 100);
      }
    },
    true,
  );
}

// Sentry.init({
//   dsn: 'https://5b13940f2c4ad2073a8f97282373d3f5@o4507548924313600.ingest.de.sentry.io/4507548927131728',
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', /^https:\/\/api\.duguntakibi\.com\.tr/, /duguntakibi\.com\.tr/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const container = document.getElementById('root');
if (container) {
  const root = ReactDOM.createRoot(container);
  // Sekme odağına dönüşte tüm sorguların sessizce yeniden çekilip içeriğin
  // "yanıp sönmesini" engeller; ihtiyaç duyan sorgu kendi seçeneğiyle açabilir.
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });
  root.render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <Provider store={store}>
          {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
          <PersistGate persistor={persistor} loading={<div>Yükleniyor...</div>}>
            <App basename={PUBLIC_URL} />
            <ToastContainer autoClose={3000} style={{ zIndex: 99999 }} />
          </PersistGate>
        </Provider>
      </MetronicI18nProvider>
    </QueryClientProvider>,
  );
} else {
  console.error('Root container missing in index.html');
}
